import React, { useState } from "react";
import { Container, Col, Row } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { IPUrl } from "../commons/IPAddress";
import Loaders from "../components/Loaders";

function ServiceFollow(props) {
  let {requestId} = useParams();
  const [load, setLoad] = useState(false);
  const userToken = localStorage.getItem("user_token");


   const hideSpinner = () => {
      setLoad(true)
    };
  return (
    <div>
   {!load ? (
          <Loaders loads={load} />
        ) : null}
  
    <Container >
      <Row className="justify-content-center pt-5">
        <Col xs={12} lg={10} className="text-center rgc-title">
          <iframe src={`${IPUrl}react/service/edit/${requestId}?token=${userToken}`}
         className="rgc-iframe"
          title="خدمات" 
          id="iframe"
          onLoad={hideSpinner}
          allow="camera *;microphone *"
          overflow></iframe>
        </Col>
        
      </Row>
    </Container>
   </div>
  );
}

export default ServiceFollow;
